import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useUnreadMessages } from '@/hooks/useUnreadMessages';
import { useAuth } from '@/hooks/useAuth';
import { motion } from 'framer-motion';

const UnreadMessagesAlert = () => {
  const { hasUnread, unreadCount } = useUnreadMessages();
  const { userRole } = useAuth();
  const navigate = useNavigate();
  
  if (!hasUnread) return null;
  
  const isAdmin = userRole === 'bizadmin' || userRole === 'owner';
  const messagesRoute = isAdmin ? '/admin/messages' : '/parent-portal/messages';

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.2 }}
      className="flex items-center cursor-pointer"
      onClick={() => navigate(messagesRoute)}
    >
      <div className="relative">
        <MessageCircle className="h-7 w-7 text-primary" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 block h-2.5 w-2.5 rounded-full bg-red-500 border-2 border-white" />
        )}
      </div>
      <span className="sr-only">
        {unreadCount} {unreadCount === 1 ? 'unread message' : 'unread messages'}
      </span>
    </motion.div>
  );
};

export default UnreadMessagesAlert;
